<template>
    <div class="mb-3">
        <div class="custom-div-outer">
            <b-row class="custom-outer-filter">
                <b-col md="4">
                    <b-form-group label="Hub Name" :label-cols="3">
                        <div id='container' style="width: 230px;">
                            <ejs-multiselect  id='multi_select2'  placeholder="Select Hub Name" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                            ></ejs-multiselect>
                        </div>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group label="Selecte From Date:"  :label-cols="5" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='selectFromDate'>
                        </v-date-picker>
                    </b-form-group>
                </b-col>

                <b-col md="4">
                    <b-form-group label="Selecte To Date:"  :label-cols="5" >
                        <v-date-picker mode='single' input-class="dateInput"
                        :available-dates='{ start: null, end: new Date() }'
                        v-model='selectToDate'>
                        </v-date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-col md="12" class="mb-5 text-right">
                <b-button variant="primary" @click="getFilterList()"> Search </b-button>&nbsp;
                <b-button variant="danger" @click="clearFilter(activeTab)"> Clear </b-button>&nbsp;
            </b-col>
            
        </div> 

        <div id="listloader" v-if="loader">
            <div class="listloader"></div>
        </div>

        <b-row>
            <b-col md="12">
                <div>
                    <ul class="nav nav-tabs nav-justified mb-3">
                        <li class="nav-item">
                            <a @click="activeTab = 0" class="nav-link text-center custom-link" :class="{'active': isActiveTab(0)}">
                                <div>Pending Requests - {{ approval_pending_count }}</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="activeTab = 1"  class="nav-link text-center custom-link" :class="{'active' : isActiveTab(1)}">
                                <div>Approved Requests - {{ approved_count }}</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="activeTab = 2"  class="nav-link text-center custom-link" :class="{'active' : isActiveTab(2)}">
                                <div>Vehicle Placed - {{ vehicle_placed_count }}</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="activeTab = 3"  class="nav-link text-center custom-link" :class="{'active' : isActiveTab(3)}">
                                <div>Rejected Requests - {{ rejected_count }}</div>
                            </a>
                        </li>
                    </ul>
                </div>
            </b-col>
  
            <b-col md="12">
                <div class="tab-panel" v-if="isActiveTab(0)">
                    <button @click="getPendingList(1,'pendingAllRequest')" class="cutom-view-all-btn">View All Requests</button>

                    <b-col sm=12 class="text-right">
                        <b>Total Records : </b><strong style="color: red;">{{pending_count}}</strong>
                    </b-col>

                    <b-table show-empty responsive :fields="fields" :items="pendingRequest" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(1,row.item,'openmodel')"><strong>{{ row.item.requestid }}</strong></button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="status" slot-scope="row">
                            <div>
                                <strong>{{ row.item.status==='Approval_Pending'?'Approval Pending': row.item.status }}</strong>
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </b-table>

                    <!-- pagination -->
                    <paginate v-model="pageNum"
                        :page-count="noofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>

                </div>


                <div class="tab-panel" v-if="isActiveTab(1)">
                    <button @click="fetchApprovalRequestData(1,'approvedAllRequest')" class="cutom-view-all-btn">View All Requests</button>

                    <b-col sm=12 class="text-right">
                        <b>Total Records : </b><strong style="color: red;">{{ApprovedRequest_count}}</strong>
                    </b-col>

                    <b-table show-empty responsive :fields="fieldsApproved" :items="ApprovedRequest" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(1,row.item,'openmodel')"><strong>{{ row.item.requestid }}</strong></button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="status" slot-scope="row">
                            <div>
                                <strong>{{ row.item.status==='Vendor_Pending'?'Vendor Pending': row.item.status=='Vehicle_Pending'?'Vehicle Pending': row.item.status=='Vendor_Reconsider'?'Vendor Reconsider':row.item.status=='Freight_Pending'?'Freight Pending':row.item.status}}</strong>
                            </div>
                        </template>
                        <template slot="lastmodifieddate" slot-scope="row">
                            <div>
                                {{row.item.lastmodifiedby + ' ' + row.item.lastmodifieddate}} 
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </b-table>

                     <!-- pagination -->
                     <paginate v-model="approvepageNum"
                     :page-count="approvenoofpages"
                     :page-range="10"
                     :margin-pages="2"
                     :click-handler="approveClickCallback"
                     :prev-text="'Prev'"
                     :next-text="'Next'"
                     :container-class="'pagination'"
                     :page-class="'page-item'">
                 </paginate>
                </div>
        


                <div class="tab-panel" v-if="isActiveTab(2)">
                    <button @click="fetchVehiclePlacedData(1,'vehiclePlacedRequest')" class="cutom-view-all-btn">View All Requests</button>

                    <b-col sm=12 class="text-right">
                        <b>Total Records : </b><strong style="color: red;">{{vehicleUpdated_count}}</strong>
                    </b-col>

                    <b-table show-empty responsive :fields="fieldsVehicleplaced" :items="vehicleUpdated" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                        <template slot="requestid" slot-scope="row">
                            <div>
                                <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(1,row.item,'openmodel')"><strong>{{ row.item.requestid }}</strong></button>
                            </div>
                        </template>
                        <template slot="delivery_locations" slot-scope="row">
                            <div>
                                <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                            </div>
                        </template>
                        <template slot="status" slot-scope="row">
                            <div>
                                <strong>{{ row.item.status==='Vehicle_Updated'?'Vehicle Updated': row.item.status}}</strong>
                            </div>
                        </template>
                        <template slot="lastmodifieddate" slot-scope="row">
                            <div>
                                {{row.item.lastmodifiedby + ' ' + row.item.lastmodifieddate}} 
                            </div>
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </b-table>

                     <!-- pagination -->
                     <paginate v-model="vehicleplacepageNum"
                     :page-count="vehicleplacenoofpages"
                     :page-range="10"
                     :margin-pages="2"
                     :click-handler="vehicleplaceClickCallback"
                     :prev-text="'Prev'"
                     :next-text="'Next'"
                     :container-class="'pagination'"
                     :page-class="'page-item'">
                 </paginate>
                </div>



                <div class="tab-panel" v-if="isActiveTab(3)">
                    <button @click="fetchVehicleRejectedData(1,'vehicleRejectedRequest')" class="cutom-view-all-btn">View All Requests</button>

                    <b-col sm=12 class="text-right">
                        <b>Total Records : </b><strong style="color: red;">{{vehicleRejected_count}}</strong>
                    </b-col>

                    <b-table show-empty responsive :fields="fieldsRejected" :items="vehicleRejected" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                            <template slot="requestid" slot-scope="row">
                                <div>
                                    <button class="cutom-view-all-btn" @click.prevent="viewPlanDetails(1,row.item,'openmodel')"><strong>{{ row.item.requestid }}</strong></button>
                                </div>
                            </template>
                            <template slot="delivery_locations" slot-scope="row">
                                <div>
                                    <b-button v-b-tooltip.hover :title="row.item.delivery_locations" class="cutom-view-all-btn">{{ row.item.delivery_locations.split(',').slice(0, 2).join(', ') }}</b-button>
                                </div>
                            </template>
                            <template slot="createddate" slot-scope="row">
                            <div>
                                {{row.item.lastmodifiedby + ' ' + row.item.lastmodifieddate}} 
                            </div>
                        </template>
                            
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                     <!-- pagination -->
                     <paginate v-model="rejectpageNum"
                     :page-count="rejectnoofpages"
                     :page-range="10"
                     :margin-pages="2"
                     :click-handler="rejectClickCallback"
                     :prev-text="'Prev'"
                     :next-text="'Next'"
                     :container-class="'pagination'"
                     :page-class="'page-item'">
                 </paginate>
                </div>
            </b-col>
        </b-row>

        <!-- plan modal start here -->
        <b-modal :title="'View Plan Screen'" v-model="plandetailsmodal" size="xl" hide-footer modal-class="text-center">
            
            <template slot="default" slot-scope="{ hide }">
                <template>
                    <b-row>
                        <b-col sm="4">
                            <b-input-group>
                                <b-input-group-prepend>
                                    <span class="d-flex text-center m-auto mr-2"><strong>Search Load :- </strong></span> &nbsp;
                                </b-input-group-prepend>&nbsp;
                                <b-form-input v-model="filter" placeholder="Enter Parent AWB / Load ID" @input="searchdata"></b-form-input>
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="clearFilterPlan">Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col  sm="3">
                            <strong>vehicle No :- </strong> <b v-if="planScrrenDetails && planScrrenDetails[0] && planScrrenDetails[0].vehicle_no">{{ planScrrenDetails[0].vehicle_no }}</b>
                        </b-col>
                        <b-col  sm="3">
                            <strong>Origin :- </strong> <b>{{ planDetails.origin }}   </b>
                        </b-col>
                        <b-col  sm="2">
                            <strong>Records :- </strong> <b class="text-danger">{{planScrrenDetails_count}}</b>
                        </b-col>
                    </b-row>
                </template>
                <div id="listloader" v-if="loadermodel">
                    <div class="listloader"></div>
                </div>
        
                <b-table show-empty responsive :fields="fieldsPlanScrren" :items="planScrrenDetails" :filter="filter" :busy="planisBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                    <template slot="parentawb" slot-scope="row">
                        <div>
                            <span class="cutom-view-plan-btn">{{ row.item.parentawb }}</span>
                        </div>
                    </template>

                    <template slot="mpscount" slot-scope="row">
                        <div>
                            <span class="cutom-view-plan-btn">{{ row.item.mpscount?row.item.mpscount:'0' }}</span>
                        </div>
                    </template>

                    <template slot="userid" slot-scope="row">
                        <div>
                            <span class="cutom-view-plan-btn">{{ row.item.userid }}</span>
                        </div>
                    </template>

                    <template slot="unload_sequence" slot-scope="row">
                        <div>
                            <span class="cutom-view-plan-btn">{{ row.item.unload_sequence }}</span>
                        </div>
                    </template>
                    <template slot="status" slot-scope="row">
                        <div>
                            <button class="cutom-btn-download" @click.prevent="downloadCSV(row.item)"><i class="fa fa-file" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </b-table>   
                <!-- pagination -->
                <paginate v-model="planviewpageNum"
                        :page-count="planviewnoofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="planViewclickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>             
            </template>
                                
            <template slot="modal-footer" slot-scope="{ hide }">
                <b-button size="sm" style="display:none">
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <!-- plan modal end here -->                    
    </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Swal from 'sweetalert2';
export default {
  name: 'MyTabs',
  data () {
        return {
            activeTab: 0, // The first tab is active by default //

            loader : false,
            loadermodel : false,

            fields : [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'createddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
            ],

            fieldsApproved: [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'createddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'lastmodifieddate', label : 'Last Modifed BY & on', sortable: true},
            ],

            fieldsVehicleplaced: [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'createddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'vehicleid', label : 'Vehicle number ', sortable: true},
                { key : 'lastmodifieddate', label : 'Last Modifed BY & on', sortable: true},
            ],

            fieldsRejected: [ 
                { key : 'requestid', label : 'Request ID', sortable: true},
                { key : 'origin', label : 'Origin', sortable: true},
                { key : 'route', label : 'Route', sortable: true},
                { key : 'vehicle_size', label : 'Vehicle Size', sortable: true},
                { key : 'delivery_locations', label : 'Delivery Locations', sortable: true},
                { key : 'delivery_points', label : 'Delivery Points', sortable: true},
                { key : 'volumetric_wt', label : 'Volumetric Wt.', sortable: true},
                { key : 'createdby', label : 'Request By', sortable: true},
                { key : 'lastmodifieddate', label : 'Request Date and Time', sortable: true},
                { key : 'status', label : 'Request Status', sortable: true},
                { key : 'reason', label : 'Status Remark.', sortable: true},
                { key : 'createddate', label : 'Last Modifed BY & on', sortable: true},
            ],

            fieldsPlanScrren : [ 
            { key : 'parentawb', label : 'Parent AWB', sortable: true, sortDirection: "desc"},
                { key : 'load_id', label : 'Load ID', sortable: true, sortDirection: "desc"},
                { key : 'mpscount', label : 'MPS Count' , sortable: true, sortDirection: "desc"},
                { key : 'destinationaddress', label : 'Destination Address', sortable: true, sortDirection: "desc"},
                { key : 'userid', label : 'User ID', sortable: true, sortDirection: "desc"},
                { key : 'destinationcity', label : 'Destination City', sortable: true, sortDirection: "desc"},
                { key : 'unload_sequence', label : 'Sequence', sortable: true, sortDirection: "desc"},
                { key : 'status', label : 'Download PDF(Invoice)', sortable: true, sortDirection: "desc"},
            ],
            
            pendingRequest: [],
            pending_count: 0,


            ApprovedRequest: [],
            ApprovedRequest_count: 0,

            vehicleUpdated: [],
            vehicleUpdated_count:0,


            vehicleRejected: [],
            vehicleRejected_count: 0,


            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            selectFromDate : null,
            selectToDate:  null,


           // plan model
           plandetailsmodal: false,
            fieldsPlanScrren : [ 
                { key : 'parentawb', label : 'Parent AWB', sortable: true, sortDirection: "desc"},
                { key : 'load_id', label : 'Load ID', sortable: true, sortDirection: "desc"},
                { key : 'mpscount', label : 'MPS Count', sortable: true, sortDirection: "desc"},
                { key : 'destinationaddress', label : 'Destination Address', sortable: true, sortDirection: "desc"},
                { key : 'userid', label : 'User ID', sortable: true, sortDirection: "desc"},
                { key : 'destinationcity', label : 'Destination City', sortable: true, sortDirection: "desc"},
                { key : 'unload_sequence', label : 'Sequence', sortable: true, sortDirection: "desc"},
                { key : 'status', label : 'Download PDF(Invoice)', sortable: true, sortDirection: "desc"},
            ],
            planScrrenDetails: [],
            planScrrenDetails_count :0,
            planisBusy:false,
            planDetails:{},


            planviewpageNum:1,
            planviewnoofpages:'',


            bordered:true,
            pageOptions: [5, 10, 15],
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,

          
            approval_pending_count: 0,
            approved_count:0,
            vehicle_placed_count:0,
            rejected_count:0,

            // 1st pagination
            noofpages:'',
            pageNum:1,

            rejectnoofpages:'',
            rejectpageNum:1,

            approvenoofpages:'',
            approvepageNum:1,

            vehicleplacepageNum:1,
            vehicleplacenoofpages:'',

            isSearch:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.isActiveTab(0);
        this.showWHlist();
        this.pendingTabCount();
        this.getPendingList(1);
       
    },
    watch: {
        activeTab(newTab, oldTab) {
            this.pendingTabCount();
            this.pageNum=1;
            this.approvepageNum=1;
            this.vehicleplacepageNum=1;
            this.rejectpageNum=1;
            this.isSearch = false;

            if (newTab === 0) {
                this.getPendingList(1);
            }
            if (newTab === 1) {
                this.fetchApprovalRequestData(1);
            }
            if (newTab === 2) {
                this.fetchVehiclePlacedData(1);
            }
            if (newTab === 3) {
                this.fetchVehicleRejectedData(1);
            }
        },
    },
  
    methods: {

        isActiveTab(id){
            return this.activeTab === id
        },

          //Pending list 
          clickCallback (pageNum){
            this.pageNum = pageNum;
            this.getPendingList(pageNum);
        },

        // fetch pending list
        getPendingList : function (pageNo,pendingAllRequest) {
            this.loader=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;

            if (pendingAllRequest === 'pendingAllRequest') {
                // userInfo.sysusermasterid=null;
                this.pageNum=1;
                this.isSearch = true;
            }

            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                    this.loader=false;
                    this.isBusy = false; 
                    return false;       
            }

            const obj = {
                // sysusermasterid: pendingAllRequest === 'pendingAllRequest'?null:`${userInfo.sysusermasterid}`,
                sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                tab: 1,
                pageno: `${pageNo}`,
                hubid: this.valueWH && this.valueWH.length === 0 ? [] : this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Approval Pending"
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.loader=false;
                if (result.body.returnmsg === 'Successful') {
                    this.pendingRequest = result.body.returnvalue;
                    this.pending_count = result.body.returnvalue[0].totalcount;
                    // this.approval_pending_count = result.body.returnvalue.length;
                    this.noofpages=parseInt(this.pending_count)/10;
                    this.noofpages=Math.ceil( this.noofpages);
                } else {
                    this.noofpages='',
                    this.pending_count = 0,
                    this.pendingRequest =[]
                    // this.approval_pending_count= 0
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        //Approve List
        approveClickCallback(approvepageNum){
            this.fetchApprovalRequestData(approvepageNum);
        },

        fetchApprovalRequestData: function (pageNo,pendingAllReq) {
        
            this.loader=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if (pendingAllReq === 'approvedAllRequest') {
                //userInfo.sysusermasterid = null
                this.approvepageNum=1;
                this.isSearch = true;
            }

            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;


            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                    this.loader=false;
                    this.isBusy = false; 
                    return false;       
            }


            const obj = {
                // sysusermasterid:`${userInfo.sysusermasterid}` === 'null' ? null : `${userInfo.sysusermasterid}`,
                sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                tab: 1,
                pageno: `${pageNo}`,
                hubid: this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Approved"
            };
            

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.loader=false;
                if (result.body.returnmsg === 'Successful') {
                    this.ApprovedRequest = result.body.returnvalue;
                    this.ApprovedRequest_count = result.body.returnvalue[0].totalcount;
                    // this.approved_count = result.body.returnvalue.length
                    this.approvenoofpages=parseInt(this.ApprovedRequest_count)/10;
                    this.approvenoofpages=Math.ceil( this.approvenoofpages);
                } else {
                    this.approvenoofpages='';
                    this.ApprovedRequest_count = 0;
                    this.ApprovedRequest = [];
                    // this.approved_count = 0
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },


        //Vehicle place
        vehicleplaceClickCallback(vehicleplacepageNum){
            this.fetchVehiclePlacedData(vehicleplacepageNum);
        },

   
        fetchVehiclePlacedData: function (pageNo,vehiclePlacedRequest) {
            this.loader=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;


            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                    this.loader=false;
                    this.isBusy = false; 
                    return false;       
            }
        
            if (vehiclePlacedRequest === 'vehiclePlacedRequest') {
               // userInfo.sysusermasterid = null
                this.vehicleplacepageNum=1;
                this.isSearch = true;
            }

            const obj = {
                // sysusermasterid:`${userInfo.sysusermasterid}` === 'null' ? null : `${userInfo.sysusermasterid}`,
                sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                tab: 1,
                pageno: `${pageNo}`,
                hubid: this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Vehicle Updated"
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.loader=false;
                if (result.body.returnmsg === 'Successful') {
                    this.vehicleUpdated = result.body.returnvalue;
                    this.vehicleUpdated_count = result.body.returnvalue[0].totalcount;
                    // this.vehicle_placed_count = result.body.returnvalue.length,
                    this.vehicleplacenoofpages=parseInt(this.vehicleUpdated_count)/10;
                    this.vehicleplacenoofpages=Math.ceil( this.vehicleplacenoofpages);
                } else {
                    this.vehicleplacenoofpages='';
                    this.vehicleUpdated_count = 0;
                    this.vehicleUpdated=[];
                    // this.vehicle_placed_count = 0
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },



        //Reject data
        rejectClickCallback(rejectpageNum){
            this.fetchVehicleRejectedData(rejectpageNum);
        },

        
        fetchVehicleRejectedData: function (pageNo,vehicleRejectedRequest) {
            this.loader=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var fromdate = (this.selectFromDate!=null)?this.formatDate(this.selectFromDate):null;
            var formatdateto=(this.selectToDate!=null)? this.formatDate(this.selectToDate):null;


            if(formatdateto< fromdate){  
              this.$fire({
                      text:"To date need to be greater than From date",
                      type: "warning",
                      timer: 30000
                    }); 
                    this.loader=false;
                    this.isBusy = false; 
                    return false;       
            }
        
            if (vehicleRejectedRequest === 'vehicleRejectedRequest') {
               // userInfo.sysusermasterid = null
                this.rejectpageNum=1;
                this.isSearch = true;
            }

            const obj = {
                // sysusermasterid:`${userInfo.sysusermasterid}` === 'null' ? null : `${userInfo.sysusermasterid}`,
                sysusermasterid: this.isSearch ? null : `${userInfo.sysusermasterid}`,
                tab: 1,
                pageno: `${pageNo}`,
                hubid: this.valueWH && this.valueWH.length === 0 ? [] : this.valueWH,
                fromdate: fromdate,
                todate: formatdateto,
                subtab: "Rejected"
            };

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehilceRequestsList`,obj).then(result => {
                this.loader=false;
                if (result.body.returnmsg === 'Successful') {
                    this.vehicleRejected = result.body.returnvalue;
                    this.vehicleRejected_count = result.body.returnvalue[0].totalcount;
                    // this.rejected_count = result.body.returnvalue.length,
                    this.rejectnoofpages=parseInt(this.vehicleRejected_count)/10;
                    this.rejectnoofpages=Math.ceil( this.rejectnoofpages);
                } else {
                    this.rejectnoofpages='';
                    this.vehicleRejected_count = 0;
                    this.vehicleRejected=[];
                    // this.rejected_count = 0
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        showWHlist:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {
                sysusermasterid:`${userInfo.sysusermasterid}`,
                usertype:`${userInfo.user_type}`
            };
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
                .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
                
                    this.WHData  = result.body.returnvalue;
                    
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                        name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                        id: this.WHData[j].hubid,
                        }
                    this.optionsWH.push(WH);
                    }
                
                } else {              
                    this.WHData  = result.body.returnvalue;
                }
            

            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        getFilterList() {
            this.isSearch = true;

            this.pendingTabCount();
            this.filterCheck = true
            this.pageNum=1;
            this.approvepageNum=1;
            this.vehicleplacepageNum=1;
            this.rejectpageNum=1;
            if (this.activeTab === 0) {
                this.getPendingList(1)
            }
            if (this.activeTab === 1) {
                this.fetchApprovalRequestData(1)
            }
            if (this.activeTab === 2) {
                this.fetchVehiclePlacedData(1)
            }
            if (this.activeTab === 3) {
                this.fetchVehicleRejectedData(1)
            }
        },

        clearFilter(active) {
            this.pendingTabCount();
            this.selectToDate = null;
            this.selectFromDate= null;
            this.valueWH= [];
            this.pageNum=1;
            this.approvepageNum=1;
            this.vehicleplacepageNum=1;
            this.rejectpageNum=1;

            if (this.activeTab === active) {
                this.pendingRequest=[];
                this.pending_count = 0;

                this.getPendingList(this.pageNum)
            }
            if (this.activeTab === active) {
                this.ApprovedRequest = [];
                this.ApprovedRequest_count = 0;

                this.fetchApprovalRequestData(this.approvepageNum)
            }
            if (this.activeTab === active) {
                this.vehicleUpdated_count = 0;
                this.vehicleUpdated=[];

                this.fetchVehiclePlacedData(this.vehicleplacepageNum)
            }
            if (this.activeTab === active) {
                this.vehicleRejected = [];
                this.vehicleRejected_count = 0;

                this.fetchVehicleRejectedData( this.rejectpageNum)
            }
        },

     
        planViewclickCallback(planviewpageNum){
            this.viewPlanDetails(planviewpageNum,this.planDetails)
        },

        viewPlanDetails(pageno,value,openmodel) {
            this.loadermodel=true;
            this.planDetails = value;
            this.plandetailsmodal = true;
            if (openmodel=='openmodel') {
                pageno=1;
                this.planviewpageNum=1;
            }
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);
            
                const obj = {
                    planid: `${value.planid}`,
                    pageno: `${pageno}`,
                };

                // return false
                this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getPlanDetailsForRequest`,obj).then(result => {
                    this.loadermodel=false;
                    if (result.body.returnmsg === 'Successful') {
                        this.planScrrenDetails = result.body.returnvalue;
                        this.planScrrenDetails_count =  result.body.totalcount;
                        this.planviewnoofpages=parseInt(this.planScrrenDetails_count)/10;
                        this.planviewnoofpages=Math.ceil( this.planviewnoofpages);
                    } else {
                        this.planviewnoofpages='';
                        this.planScrrenDetails = [];
                        this.planScrrenDetails_count = 0;
                    }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });
            
        },

        downloadCSV(value){
            this.loadermodel=true;
            console.log("value",value)
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            let parent = [];

            parent.push(value.parentawb)

            let obj = {
                parentawb:parent,
                userId: value.userid,
                platform: "web"
            }

            // return false;
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadAllDocAWBWise`,obj)
                .then((result) => {
                    this.loadermodel=false;
                    if (result.body.returnmsg === 'Successful') {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "success",
                            timer: 30000
                        });
                        
                    } else {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 30000
                            });
                    
                    }
                }).catch((ex) => {
                    console.log('error-----', ex)
                })
        },

        // count of all tab
        pendingTabCount() {
            this.loader=true;
                var userdata = localStorage.getItem("userData");
                var userInfo = JSON.parse(userdata);
            
                const obj = {
                    "tab": 1,
                    "sysusermasterid": null,
                };

                // return false
                this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getAdhocVehicleRequestsCount`,obj).then(result => {
                    this.loader=false;
                    if (result.body.returnmsg === 'Successful') {
                        console.log(result.body, 'aaabb adhoc');
                        this.approval_pending_count = result.body.returnvalue['Approval Pending'];
                        this.approved_count = result.body.returnvalue['Approved'];
                        this.vehicle_placed_count = result.body.returnvalue['Vehicle Updated'];
                        this.rejected_count = result.body.returnvalue['Rejected'];
                    } else {
                        this.approval_pending_count = 0;
                        this.approved_count = 0;
                        this.vehicle_placed_count = 0;
                        this.rejected_count = 0;
                    }
                })
                .catch((ex) => {
                    console.log("error", ex);
                });
        },

        // format Date function
        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-")
        },

        clearFilterPlan() {
            console.log('git click here');
            this.filter = null
        }

  }
};
</script>


<style scoped>
.cutom-btn-download {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 15px;
    background: #f09642 !important;
    border: 1px solid #f09642 !important;
} 
.tab-content {
margin-top: 20px;
}

.nav-link {
    color: #6c757d;  /* Customize the text color */
    background-color: #f8f9fa; /* Customize the background */
    border-color: #dee2e6;    
}
.tabs .nav-tabs {
    display: flex;
    justify-content: center; /* Centers the tabs horizontally */
    align-items: center; /* Centers the content vertically */
}


.custom-outer-filter {
    padding-top: 25px;
    padding-left: 15px;
}


.cutom-view-all-btn {
border: none !important;
border-radius: 10px !important;
/* margin-left: 15px !important; */
background-color: #E8E4E4 !important;
padding: 4px !important;
}

.cutom-view-all-btn:focus {
border: none !important;
border-radius: 10px !important;
/* margin-left: 15px !important; */
outline: none !important;
background-color: #E8E4E4 !important;
box-shadow: none !important;
padding: 4px !important;
}

.nav-link {
    background: #66635BAD !important;
    border-radius: 10px !important;
    margin-bottom: 20px;
  }
  .nav-link.active {
    background-color: #66635BAD !important;
    background: #00BDF0 !important;
    margin-bottom: 20px;
}


.nav-link {
        background: #7B7B7B !important;
        border-radius: 20px;
        border: none;
    }
    .nav-link.active {
        background: #F8943F !important;
    border-radius: 20px;
    border: none;
  }

  .nav-tabs {
    border-bottom: none !important;
}

.custom-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.custom-link i {
    font-size: 24px; /* Adjust icon size */
    margin-bottom: 5px; /* Add space between icon and text */
    color: #fff; /* Set icon color to white */
}

.custom-link div {
    font-size: 16px; /* Adjust text size */
    color: #fff !important;
}
.cutom-view-plan-btn {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}
.cutom-view-plan-btn:focus {
    background: #DAE7FA !important;
    align-items: center;
    border-radius: 5px;
    border: none;
    color: #276F97 !important;
    padding: 4px;
}

.modal-center-title .modal-header {
    justify-content: center;
    width: 100%;
}

.modal-center-title .modal-title {
    text-align: center;
    width: 100%;
}
</style>